export default __webpack_public_path__ + "static/media/brainster-next-cover.9c8b7fcc.jpg";